import { AmplifyConfig, InterfaceConfig } from "@interfaces/response";

export const interfaceConfig: InterfaceConfig = {
  name: "finbe",
  terminos_condiciones_empresa: import.meta.env.VITE_URL_HOME_FINBE + "/terminos-y-condiciones-credito-empresarial",
  interest_rate: 30,
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyAiV-uuz8-emZFpk28KuxPiy95Y_yKZIp0"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: [
    "Financiera Bepensa SA DE CV SOFOM ER",
    "Bepensa Leasing SA DE CV",
    "AB&C Leasing de México SAPI DE CV",
    "Lendit Group SAPI de CV",
  ],
  firma: {
    video_url:
      import.meta.env.VITE_ENV === "PROD"
        ? "https://static-resource.lendia.mx/finbe/portal/media/customer_welcome-signature.mp4"
        : "https://static-resource.lenditgroup.com/finbe/portal/media/customer_welcome-signature.mp4",
    provider: "legalario",
    legalario_config: {
      custom_url_sdk: import.meta.env.VITE_ENV === "PROD" ? "https://sdk.legalario.com/finBe/sdk-dist.js" : "",
      organization_id: import.meta.env.VITE_ENV === "PROD" ? "6834e22990aa7213b84e5522" : "680fb72a3750460f1c548673",
      api_key:
        import.meta.env.VITE_ENV === "PROD"
          ? "7f9c2ba4e88f827d616045507605853ed73b8093a03f8aa2b7e0e2c78c1e6025"
          : "f65d302d4fbdd71f13fd629e0b67a8971afa1f72cc931bc55f6c6e1f2094fdab",
      modules: ["documents", "signature", "biometrics"],
    },
    condiciones_credito: {
      monto: true,
      plazo: true,
      tasa: false,
    },
    habilitar_calendario_pagos: true,
    habilitar_tabla_amortizacion: true,
  },
  scripts: {
    tag_id_google: "G-GRSNLB3TYW",
    tag_id_linkedin: "6355068",
    tag_id_hotjar: "6412809",
    tag_id_meta_pixel: "1135735424251241",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_YWntpKnYk",
      userPoolClientId: "4qiq9837g21na4jrpnm6s6rokd",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_6Kcxh4l1m",
      userPoolClientId: "5fveuoevde7c8f7scm3dbm5j63",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
